module.exports = __webpack_public_path__ + "img/samsung_step3.9d3ded93.png";